import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { useRecoilState } from 'recoil';
import { ThemeAtomState } from './recoil/ModalAtom';
import { lightTheme, darkTheme } from './theme';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${p => p.theme.bg};
    color: ${p => p.theme.text};
    transition: background-color 0.3s ease, color 0.3s ease;
  }
`;

const ThemeWrapper = ({ children }) => {
  const [themeMode] = useRecoilState(ThemeAtomState);
  const theme = themeMode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
